module.exports = __webpack_public_path__ + "static/21-03-27_09-26-35_4775-9518213a1ebaaf56174eff69b568513e.png";